export const STATUS = [
  'online',
  'offline',
  ''
]

export const SIZE = [
  'regular',
  'medium',
  ''
]

export const COLOR = [
  'white',
  ''
]
